import resolve from '../../../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../../../modules/apiHelper';

export default {
  async getCompanyProgramGoalsBadges(context, [companyId, programId]) {
    const goals = await context.dispatch('getProgramGoals', {
      companyid: companyId,
      progid: programId,
    });

    const result = await resolve(apiPost('prog_goal_badge_list', generateFormData({
      companyid: companyId,
      progid: programId,
    }), 86))
      .then((res) => {
        if (!res) return false;

        const goalsBadges = res.prog_goal_badge_list.map((goalBadge) => {
          // eslint-disable-next-line no-param-reassign
          goalBadge.goal = goals.find((goal) => Number(goal.id) === Number(goalBadge.goalid)) || {};

          return goalBadge;
        });

        return goalsBadges;
      });
    //

    return result;
  },

  async createProgramGoalBadge(context, data) {
    const formData = generateFormData({
      badge_name: data.name,
      desc: data.description,
      goalid: data.goalId,
      companyid: data.companyId,
      progid: data.programId,
      senderid: context.rootState.User.id,
    });
    formData.append('file1', data.badge);

    const result = await resolve(apiPost('create_prog_goal_badge', formData, 86));

    return result;
  },

  async deleteProgramGoalBadge(context, badgeId) {
    const result = await resolve(apiPost('prog_del_goal_badge', generateFormData({
      badgeid: badgeId,
    }), 86));

    return result;
  },
};
